module.exports = __webpack_public_path__ + "static/oval5.9f629a1c.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/oval5.png
// module id = 256
// module chunks = 0